'use strict';

const helper = require('../../helper');
const venmoAccount = require('./venmoAccount');
const venmoCheckout = require('./venmoCheckout');
const venmoExpressCheckout = require('./venmoExpressCheckout');

/**
 * Process Venmo flow for Account/Billing Page flows
 * @param {Object} venmoData Venmo data received from tokenize
 * @param {string} pageFlow Current page flow
 */
async function processVenmo(venmoData, pageFlow) {
    const venmoButtonEl = document.querySelector('.js-braintree-account-venmo-button, .js-braintree-venmo-button');

    if (venmoButtonEl && helper.tryParseJSON(venmoButtonEl.getAttribute('data-braintree-config'))) {
        const VenmoAlertHandlerModel = require('../alertHandler/venmoAlertHandlerModel');
        const alertHandler = new VenmoAlertHandlerModel();

        alertHandler.hideAlerts();
    }

    switch (pageFlow) {
        case window.braintreeConstants.PAGE_FLOW_ACCOUNT:
            venmoAccount.storeNewVenmoAccount(venmoData);

            break;
        case window.braintreeConstants.PAGE_FLOW_BILLING:
            helper.removeActiveSessionPayment();
            venmoCheckout.processCheckoutFlow(venmoData);

            break;
        default:
            await venmoExpressCheckout.processExpressCheckoutFlow(venmoData);

            break;
    }
}

module.exports = {
    processVenmo
};
